module.exports = __webpack_public_path__ + "img/parameter.149da222.png";